import api from "./axiosInstance";
import apiRoutes from "./api_route";

export const fetchRoomsApi = async (userId) => {
  const response = await api.get(apiRoutes.rooms.list, {
    params: { userId },
  });
  return response.data;
};

export const startMeetingApi = async (meetingData) => {
  const response = await api.post(apiRoutes.rooms.start, meetingData);
  return response.data;
};

export const completeRoomApi = async (roomId, userId) => {
  const response = await api.put(apiRoutes.rooms.complete(roomId), { userId });
  return response.data;
};

export const joinMeetingApi = async ({
  roomCode,
  roomPassword,
  phoneNumber,
  identity,
}) => {
  const response = await api.post(apiRoutes.rooms.joinRequest, {
    roomCode,
    roomPassword,
    phoneNumber,
    identity,
  });
  return response.data;
};

export const checkJoinStatusApi = async (meetingCode, phoneNumber) => {
  const response = await api.get(apiRoutes.rooms.joinStatus(meetingCode), {
    params: phoneNumber ? { phoneNumber } : {},
  });
  return response.data;
};

export const getWaitingParticipantsApi = async (meetingCode) => {
  const response = await api.get(apiRoutes.rooms.waiting(meetingCode));
  return response.data;
};

export const approveParticipantApi = async (roomCode, phoneNumber) => {
  const response = await api.post(apiRoutes.rooms.approve(roomCode), {
    phoneNumber,
  });
  return response.data;
};

export const rejectParticipantApi = async (roomCode, phoneNumber) => {
  const response = await api.post(apiRoutes.rooms.reject(roomCode), {
    phoneNumber,
  });
  return response.data;
};

export const removeParticipantApi = async (roomCode, phoneNumber) => {
  const response = await api.post(apiRoutes.rooms.remove(roomCode), {
    phoneNumber,
  });
  return response.data;
};

export const leaveMeetingApi = async (roomCode, phoneNumber) => {
  const response = await api.post(apiRoutes.rooms.leave(roomCode), {
    phoneNumber,
  });
  return response.data;
};

export const adminJoinMeetingApi = async ({
  roomCode,
  roomPassword,
  identity,
  phoneNumber,
}) => {
  const response = await api.post(apiRoutes.rooms.adminJoin, {
    roomCode,
    roomPassword,
    identity,
    phoneNumber,
  });
  return response.data;
};
